export const BOOKING_FORM_SEARCH_COOKIE_KEY = 'bookingFormSearchCookieKey';
